import React, { useEffect, useRef, useState } from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";

import Colors from "../../../../Resources/Color";
import {
  RECIPE_EDITOR_FIELD_LABEL_LINE_HEIGHT,
  RECIPE_EDITOR_NAME_INPUT_HEIGHT,
} from "../../recipes/recipeLogic";
import { useDevice } from "../../../_layout";
import { MAX_NUTRITION_NAME_LENGTH } from "../../nutritionLimits";

export function EquivalentEditorDetailsSection({
  t,
  form,
  updateFormField,
}) {
  const { isMobile } = useDevice();
  const [isNameInputHovered, setIsNameInputHovered] = useState(false);
  const nameInputRef = useRef(null);
  const hasAutoFocusedRef = useRef(false);

  useEffect(() => {
    if (hasAutoFocusedRef.current) {
      return;
    }

    if (String(form?.name ?? "").trim().length > 0) {
      hasAutoFocusedRef.current = true;
      return;
    }

    const focusInput = () => {
      nameInputRef.current?.focus?.();
      hasAutoFocusedRef.current = true;
    };

    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(focusInput);
      return;
    }

    const timeoutId = setTimeout(focusInput, 0);
    return () => clearTimeout(timeoutId);
  }, [form?.name]);

  return (
    <View style={styles.formField}>
      <Text style={styles.fieldLabel}>{t("name-string")}</Text>
      <View
        onMouseEnter={!isMobile ? () => setIsNameInputHovered(true) : undefined}
        onMouseLeave={!isMobile ? () => setIsNameInputHovered(false) : undefined}
        style={[
          styles.nameInputShell,
          isNameInputHovered ? styles.nameInputShellHovered : null,
        ]}
      >
        <TextInput
          ref={nameInputRef}
          value={form.name}
          onChangeText={(value) => updateFormField("name", value)}
          maxLength={MAX_NUTRITION_NAME_LENGTH}
          placeholder={t("equivalentNamePlaceholder-string")}
          placeholderTextColor={Colors.grayColor}
          style={styles.nameInput}
          accessibilityLabel={t("name-string")}
          aria-label={t("name-string")}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  formField: {
    width: "100%",
    gap: 10,
  },
  fieldLabel: {
    fontSize: 12,
    lineHeight: RECIPE_EDITOR_FIELD_LABEL_LINE_HEIGHT,
    fontWeight: "600",
    color: Colors.darkgrayColor,
    letterSpacing: 0.2,
  },
  nameInputShell: {
    backgroundColor: Colors.whiteColor,
    borderWidth: 1,
    borderColor: Colors.borderColor,
    borderRadius: 12,
    minHeight: RECIPE_EDITOR_NAME_INPUT_HEIGHT,
    paddingHorizontal: 12,
    flexDirection: "row",
    alignItems: "center",
    transition:
      "border-color 180ms ease-in-out, background-color 180ms ease-in-out",
  },
  nameInputShellHovered: {
    borderColor: Colors.grayColor,
  },
  nameInput: {
    flex: 1,
    minWidth: 0,
    fontSize: 13,
    fontWeight: "400",
    color: Colors.blackColor,
    outlineStyle: "none",
    paddingVertical: 10,
  },
});
